import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-right: ${props => props.paddingRight && '8px'};

  @media only screen and (max-width: 850px) {
    width: 100%;
  }
`;

export default Container;
